import { useState } from 'react';

import { DialogType } from '../../type/DialogType';

const initDialog = {
	isOpened: false,
	title: '',
	text: '',
};

/**
 * ダイアログ表示の状態管理用カスタムフック
 */
export const useStateDialog = () => {
	const [dialog, setDialog] = useState<DialogType>(initDialog); // ダイアログ表示の管理

	// ダイアログを閉じる処理
	const onCloseDialog = () => {
		setDialog(initDialog);
	};

	return {
		dialog,
		setDialog,
		onCloseDialog,
	};
};
